export default __webpack_public_path__ + "static/media/certificate-crop.c688f3cc.png";